import { gql } from '@apollo/client';

export const USER_ACCOUNTS_QUERY = gql`
    query accounts($email: String!) {
        accounts(email: $email) {
            id
            name
            email
            business
            businessDetails {
                name
                status
                fullName
                contactEmail
                uiLogoUrl
                uiBackgroundImageUrl
                uiPrimaryColor
                uiSecondaryColor
                paymentGatewayId
                tagline
            }
            profilePhoto
            staffRole
            permissions {
                action
                resource
                allowed
            }
            dependents {
                id
            }
            accountManagers {
                id
            }
            clients {
                id
            }
        }
    }
`;

export default USER_ACCOUNTS_QUERY;
